import GestaoAprovacao from '../../../../spa/gestao-aprovacao/GestaoAprovacao';

export default {
  path: 'gestao-aprovacao',
  name: 'gestao-aprovacao',
  component: GestaoAprovacao,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/gestao-aprovacao.js